import {Map, List, fromJS} from 'immutable';
import axios from "axios/index";
import { toast } from "react-toastify";

if (sessionStorage.getItem("authToken")) {
    axios.defaults.headers.common['Auth-Token'] = sessionStorage.getItem("authToken");
}

export const types = {
    INIT: 'AREACONROL/INIT',
    FETCH_AREA_CONTROLLED_ITEMS: 'AREACONROL/FETCH_AREA_CONTROLLED_ITEMS',
    FETCH_AREA_CONTROLLED_ITEMS_SUCCESS: 'AREACONROL/FETCH_AREA_CONTROLLED_ITEMS_SUCCESS',
    FETCH_MODULES: 'FETCH_MODULES',
    FETCH_MODULES_SUCCESS: 'FETCH_MODULES_SUCCESS',
    UPDATE_QUERY: 'AREACONROL/UPDATE_QUERY',
    UPDATE_MODULE_FILTER: 'AREACONTROL/UPDATE_MODULE_FILTER',
    CHANGE_PAGE: 'AREACONROL/CHANGE_PAGE',
    SET_PAGE_SIZE: 'AREACONROL/SET_PAGE_SIZE',
    UPDATE_REPLENISHMENT_STATUS_FILTER: 'AREACONROL/UPDATE_REPLENISHMENT_STATUS_FILTER',
    UPDATE_STOCK_STATUS_FILTER: 'AREACONROL/UPDATE_STOCK_STATUS_FILTER',
    UPDATE_REFILL_STATUS_FILTER: 'AREACONTROL/UPDATE_REFILL_STATUS_FILTER',
    DISABLE_AREA_CONTROL: 'AREACONROL/DISABLE_AREA_CONTROL',
    ENABLE_AREA_CONTROL: 'AREACONROL/ENABLE_AREA_CONTROL',
    UPDATE_SORT_PROPERTIES: 'AREACONTOL/UPDATE_SORT_PROPERTIES'
};

export const initialState = fromJS({
    areaControlledItems: [],
    filters: {
        replenishmentStatus: 'ALL',
        stockStatus: 'ALL',
        refillStatus: 'ALL',
        modulesSelected: []
    },
    sortProperties: {
        propertyToSortBy: 'id',
        sortDirection: 'asc'
    },
    pagination: {
        page: 0,
        pageSize: 25,
        totalPages: 0,
        totalElements: 0
    },
    query: '',
    modules: []
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT:
            return state;
        case types.FETCH_AREA_CONTROLLED_ITEMS_SUCCESS:
            return state
                .set('areaControlledItems', fromJS(action.items))
                .setIn(['pagination', 'totalPages'], fromJS(action.totalPages))
                .setIn(['pagination', 'totalElements'], fromJS(action.totalElements));
        case types.FETCH_MODULES_SUCCESS:
            return state.set('modules', fromJS(action.modules));
        case types.UPDATE_QUERY:
            return state.set('query', action.query).setIn(['pagination', 'page'], fromJS(0));
        case types.UPDATE_MODULE_FILTER:
            return state.setIn(['filters', 'modulesSelected'], fromJS(action.modulesSelected));
        case types.CHANGE_PAGE:
            return state.setIn(['pagination', 'page'], fromJS(action.page));
        case types.SET_PAGE_SIZE:
            return state.setIn(['pagination', 'pageSize'], fromJS(action.pageSize))
                .setIn(['pagination', 'page'], fromJS(0));
        case types.UPDATE_REPLENISHMENT_STATUS_FILTER:
            return state.setIn(['filters', 'replenishmentStatus'], fromJS(action.replenishmentStatus))
                .setIn(['pagination', 'page'], fromJS(0));
        case types.UPDATE_STOCK_STATUS_FILTER:
            return state.setIn(['filters', 'stockStatus'], fromJS(action.stockStatus))
                .setIn(['pagination', 'page'], fromJS(0));
        case types.UPDATE_REFILL_STATUS_FILTER:
            return state.setIn(['filters', 'refillStatus'], fromJS(action.refillStatus)).setIn(['pagination', 'page'], fromJS(0));
        case types.UPDATE_SORT_PROPERTIES:
            return state
            .setIn(['sortProperties', 'propertyToSortBy'], fromJS(action.propertyToSortBy))
            .setIn(['sortProperties', 'sortDirection'], fromJS(action.sortDirection));
        default:
            return state
    }
};

export const initialise = () => {
    return (dispatch) => {
        dispatch(fetchAreaControlledItems());
    }
};

export const fetchAreaControlledItems = () => {
    return function (dispatch, getState) {

        const {query, filters, pagination, sortProperties} = getState().areacontrol.toJS();

        let moduleString = filters.modulesSelected.join(',');

        const path = __API__ +
            `/api/ui/areacontrol?search=${query}&stockStatus=${filters.stockStatus}&refillStatus=${filters.refillStatus}&replenishmentStatus=${filters.replenishmentStatus}&page=${pagination.page}&pageSize=${pagination.pageSize}&propertyToSortBy=${sortProperties.propertyToSortBy}&sortDirection=${sortProperties.sortDirection}&modules=${moduleString}`;

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(data => {
                dispatch(fetchAreaControlledItemsSuccess(data.content, data.totalPages, data.totalElements));
            })
            .catch(error => {
                console.log(error)
                // dispatch(errorHandler(error.response))
            });
    }
};

export const fetchAreaControlledItemsSuccess = (items, totalPages, totalElements) => {
    return {
        type: types.FETCH_AREA_CONTROLLED_ITEMS_SUCCESS,
        items: items,
        totalPages: totalPages,
        totalElements: totalElements
    };
};

export const fetchModules = () => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/module';

        return axios.get(path)
        .then(response => {
            return response.data;
        })
        .then(modules => {
            dispatch(fetchModulesSuccess(modules));
        })
        .catch(error => {
            console.log(error)
        });
    }
};

export const fetchModulesSuccess = (modules) => {
    return {
        type: types.FETCH_MODULES_SUCCESS,
        modules: modules
    };
};

export const updateQuery = (query) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_QUERY,
            query: query
        });
        dispatch(fetchAreaControlledItems());
    }
};

export const updatePage = (newPage) => {
    return {
        type: types.CHANGE_PAGE,
        page: newPage
    }
};

export const changePage = (newPage) => {
    return function (dispatch) {
        dispatch(updatePage(newPage));
        dispatch(fetchAreaControlledItems());
    }
};

export const setPageSize = (pageSize) => {
    return function (dispatch) {
        dispatch({
            type: types.SET_PAGE_SIZE,
            pageSize: pageSize
        });
        dispatch(fetchAreaControlledItems());
    }
};

export const removeFromAreaControl = (itemIdsToRemove) => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/areacontrol/removeitemsfromstore';
        const command = {
            itemIdsToRemove: itemIdsToRemove
        };

        return axios.post(path, command)
            .then(response => {
                dispatch(fetchAreaControlledItems());
            })
            .then(() => {
                toast.success('Flächensteuerung beendet');
            })
            .catch(error => {
                toast.error('Flächensteuerung konnte nicht beendet werden');
            });
    }
};

export const toggleAreaControl = (areaControlledItemId, shouldBeActive) => {
    return function (dispatch) {

        let areaControlledItems = [];
        areaControlledItems.push(areaControlledItemId);

        if (shouldBeActive) {
            return dispatch(enableAreaControl(areaControlledItems));
        } else {
            return dispatch(disableAreaControl(areaControlledItems));
        }
    }
};

export const enableAreaControl = (itemIdsToActivate) => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/areacontrol/enable';
        const command = {
            itemIdsToActivate: itemIdsToActivate
        };

        return axios.put(path, command)
            .then(response => {
                dispatch(fetchAreaControlledItems());
            })
            .catch(error => {
                console.log(error);
            });
    }
};

export const updateMinimumStockQuantity = (itemId, minimumStockQuantity) => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/areacontrol/updateminimumstockquantity';
        const command = {
            areaControlledItemId: itemId,
            minimumStockQuantity: minimumStockQuantity
        };

        return axios.put(path, command)
            .then(response => {
                dispatch(fetchAreaControlledItems());
                toast.success('Mindestbestand geändert');
            })
            .catch(error => {
                toast.error('Mindestbestand konnte nicht geändert werden!');
            });
    }
};


export const disableAreaControl = (itemIdsToDeactivate) => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/areacontrol/disable';
        const command = {
            itemIdsToDeactivate: itemIdsToDeactivate
        };

        return axios.put(path, command)
            .then(response => {
                dispatch(fetchAreaControlledItems());
            })
            .catch(error => {
                console.log(error);
            });
    }
};

export const disapproveForRefill = (itemIdsToDisapprove) => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/areacontrol/disapprove';
        const command = {
            itemIdsToDisapprove: itemIdsToDisapprove
        };

        return axios.put(path, command)
        .then(response => {
            dispatch(fetchAreaControlledItems());
        })
        .catch(error => {
            toast.error('Freigabe konnte nicht beendet werden!');
        });
    }
};

export const approveForRefill = (itemIdsToApprove) => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/areacontrol/approve';
        const command = {
            itemIdsToApprove: itemIdsToApprove
        };

        return axios.put(path, command)
            .then(response => {
                dispatch(fetchAreaControlledItems());
            })
            .catch(error => {
                toast.error('Freigabe konnte nicht gesetzt werden!');
            });

    }
};

export const forceReplenishment = (id) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/releasedreplenishment/force`;

        const command = {
            id: id
        };

        return axios.post(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchAreaControlledItems());
                toast.success('Die Nachversorgung wurde ausgelöst');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchAreaControlledItems([]));
            });
    }
};

export const updateReplenishmentStatusFilter = (status) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_REPLENISHMENT_STATUS_FILTER,
            replenishmentStatus: status
        });
        dispatch(fetchAreaControlledItems());
    };
};

export const updateStockStatusFilter = (status) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_STOCK_STATUS_FILTER,
            stockStatus: status
        });
        dispatch(fetchAreaControlledItems());
    };
};

export const updateRefillStatusFilter = (status) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_REFILL_STATUS_FILTER,
            refillStatus: status
        });
        dispatch(fetchAreaControlledItems());
    };
};


export const updateModuleFilter = (modulesSelected) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_MODULE_FILTER,
            modulesSelected: modulesSelected
        });
        dispatch(fetchAreaControlledItems());
    }
};

export const updateSortProperty = (propertyToSortBy) => {
    return function (dispatch, getState) {
        const {sortProperties} = getState().areacontrol.toJS();
        const asc = 'asc';
        const desc = 'desc';
        let sortDirection = 'asc';
        if (sortProperties.propertyToSortBy === propertyToSortBy) {
            sortDirection = sortProperties.sortDirection === asc ? desc : asc;
        }
        dispatch({
            type: types.UPDATE_SORT_PROPERTIES,
            propertyToSortBy: propertyToSortBy,
            sortDirection: sortDirection
        });
        dispatch(fetchAreaControlledItems());
    }
};



// WEBPACK FOOTER //
// ./src/admin/areacontrol/overview/reducer.js